export default {
    Loading: false,
    MenuActive: {},
    IsTokenExpired: true,
    IsExpandSibar: true
}